import script from "./SingleSideCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSideCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./SingleSideCarousel.vue?vue&type=style&index=0&id=6f61446d&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f61446d"]])

export default __exports__